import { jsx } from "react/jsx-runtime";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import { validateTidalLicense } from "../../base/index.js";
function PersonAddOutlined(props) {
  return /* @__PURE__ */ jsx(
    PersonAddOutlinedIcon,
    {
      "data-testid": "PersonAddOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PersonAddOutlined",
      "data-tidal-icon-meta": "people,persona"
    }
  );
}
PersonAddOutlined.tidalIconMeta = {
  categories: "people,persona",
  name: "PersonAddOutlined"
};
validateTidalLicense();
export {
  PersonAddOutlined
};
//# sourceMappingURL=PersonAddOutlined.js.map
